export default __webpack_public_path__ + "static/media/hosting.89b06c0b.svg";